import slider1 from "./assets/slider1.png";
import slider2 from "./assets/slider2.png";
import slider3 from "./assets/slider3.png";

import category1 from "./assets/category1.jpg";
import category2 from "./assets/category2.jpg";
import category3 from "./assets/category3.jpg";

import products1 from "./assets/products1.png";
import products2 from "./assets/products2.png";
import products3 from "./assets/products3.png";
import products4 from "./assets/products4.png";
import products5 from "./assets/products5.png";
import products6 from "./assets/products6.png";
import products7 from "./assets/products7.png";
import products8 from "./assets/products8.png";
import products9 from "./assets/products9.png";
import products10 from "./assets/products10.png";
import products11 from "./assets/products11.png";
import products12 from "./assets/products12.png";
import products13 from "./assets/products13.png";
import products14 from "./assets/products14.png";
import products15 from "./assets/products15.png";
import products16 from "./assets/products16.png";

export const sliderItems = [
  {
    id: 1,
    img: slider1,
    title: "Fall Collection",
    desc: "Trending Now: Bold Colors and Prints. Up to 50% Off Selected Items",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: slider2,
    title: "Spring Trend",
    desc: "Best Sellers: Must-Have Wardrobe Pieces. Don't Miss Out!",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: slider3,
    title: "Summer Essentials",
    desc: "Elevate Your Style with Our Latest Collection. Up to 50% Off Selected Items",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: category1,
    title: "Fall Collection",
  },
  {
    id: 2,
    img: category2,
    title: "Spring Trend",
  },
  {
    id: 3,
    img: category3,
    title: "Summer Essentials",
  },
];

export const newArrivals = [
  {
    id: 1,
    img: products1,
    title: "Casual Dress Fall",
    price: 34.99,
  },
  {
    id: 2,
    img: products2,
    title: "Summer dress",
    price: 22.99,
  },
  {
    id: 3,
    img: products3,
    title: "Essential top",
    price: 49.99,
  },
  {
    id: 4,
    img: products4,
    title: "spring going out",
    price: 45.99,
  },
];

export const bestsellers = [
  {
    id: 5,
    img: products5,
    title: "faux suede jacket",
    price: 54.99,
  },
  {
    id: 6,
    img: products6,
    title: "Puffer Jacket",
    price: 72.99,
  },
  {
    id: 7,
    img: products7,
    title: "Wool Coat",
    price: 99.99,
  },
  {
    id: 8,
    img: products8,
    title: "Lightweight Puffer Jacket",
    price: 65.99,
  },
];

export const allProducts = [
  {
    id: 1,
    img: products1,
    title: "Casual Dress Fall",
    price: 34.99,
  },
  {
    id: 2,
    img: products2,
    title: "Summer dress",
    price: 22.99,
  },
  {
    id: 3,
    img: products3,
    title: "Essential top",
    price: 49.99,
  },
  {
    id: 4,
    img: products4,
    title: "spring going out",
    price: 45.99,
  },
  {
    id: 5,
    img: products5,
    title: "faux suede jacket",
    price: 54.99,
  },
  {
    id: 6,
    img: products6,
    title: "Puffer Jacket",
    price: 72.99,
  },
  {
    id: 7,
    img: products7,
    title: "Wool Coat",
    price: 99.99,
  },
  {
    id: 8,
    img: products8,
    title: "Lightweight Puffer Jacket",
    price: 65.99,
  },
  {
    id: 9,
    img: products9,
    title: "Cardigan Sweaters",
    price: 32.99,
  },
  {
    id: 10,
    img: products10,
    title: "long sleeve top",
    price: 24.99,
  },
  {
    id: 11,
    img: products11,
    title: "long fur coat",
    price: 69.99,
  },
  {
    id: 12,
    img: products12,
    title: "sweatshirt",
    price: 25.99,
  },
  {
    id: 13,
    img: products13,
    title: "long jacket",
    price: 64.99,
  },
  {
    id: 14,
    img: products14,
    title: "long vest",
    price: 52.99,
  },
  {
    id: 15,
    img: products15,
    title: "winter suits",
    price: 89.99,
  },
  {
    id: 16,
    img: products16,
    title: "t-shirt",
    price: 20.99,
  },
];

export const footerLinks = [
  {
    id: 1,
    title: "Home",
  },
  {
    id: 2,
    title: "Cart",
  },
  {
    id: 3,
    title: "Men Fashion",
  },
  {
    id: 4,
    title: "Women Fashion",
  },
  {
    id: 5,
    title: "Accessories",
  },
  {
    id: 6,
    title: "My Account",
  },
  {
    id: 7,
    title: "Order Tracking",
  },
  {
    id: 8,
    title: "Wishlist",
  },
];
